import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	TABLET_BP,
	COLOR_TEXT_PRIMARY_B2C,
} from "@website-builder/utilities-index";

export const QuestionsPanelWrapper = styled.div`
	max-width: 928px;
	margin: 0 auto;
`;

export const FAQWrapper = styled.div`
	padding: 60px 0;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	h2.header {
		margin: 0 0 46px;
		padding: 0 10px;
		font-size: 28px;
		text-align: center;
		font-weight: ${FONT_WT_MEDIUM};
		line-height: 1.4;
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		${(props) => (props.showInTabletAndMobile ? "" : "display: none;")}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 35px 30px;
		h2.header {
			margin: 0 0 30px;
			font-size: 26px;
		}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 35px 20px;
	}
`;

export const ButtonWrapper = styled.div`
	text-align: center;
	margin-top: 35px;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		button {
			padding: 0 20px;
		}
	}
`;
